import { defineStore } from "pinia";
import { ref } from "vue";
import type { currencyType } from "../service/currencyType/types";
import { executive } from "@/types/executive";

export const useExecutivesStore = defineStore(
  "executive",
  () => {
    const executive = ref<executive>({
      executiveName: "",
      executiveEmail: "",
      executivePhone: "",
    });

    return {
      executive,
    };
  },
  {
    persist: true,
  }
);
